<template>
  <div>
    <v-toolbar
        dark
        color="#00004d"
    >
      <v-btn
          icon
          dark
          @click="$emit('closeTreeDialog')"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title class="pl-0 hidden-sm-and-down">
        <span>{{ item.country ? item.country.title : '' }}</span>
        <v-icon v-if="item.country" dark x-small class="ml-1 mr-1">fas fa-angle-double-right</v-icon>

        <span>{{ item.city ? item.city.title : '' }}</span>
        <v-icon v-if="item.city" dark x-small class="ml-1 mr-1">fas fa-angle-double-right</v-icon>

        <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development.parent_development) ? item.development.parent_development.parent_development.parent_development.parent_development.parent_development.commercial_title : '' }}</span>
        <v-icon
            v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development.parent_development"
            dark x-small class="ml-1 mr-1">fas fa-angle-double-right
        </v-icon>

        <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development) ? item.development.parent_development.parent_development.parent_development.parent_development.commercial_title : '' }}</span>
        <v-icon
            v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development"
            dark x-small class="ml-1 mr-1">fas fa-angle-double-right
        </v-icon>

        <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development) ? item.development.parent_development.parent_development.parent_development.commercial_title : '' }}</span>
        <v-icon
            v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development"
            dark x-small class="ml-1 mr-1">fas fa-angle-double-right
        </v-icon>

        <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development) ? item.development.parent_development.parent_development.commercial_title : '' }}</span>
        <v-icon
            v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development"
            dark x-small class="ml-1 mr-1">fas fa-angle-double-right
        </v-icon>

        <span>{{ (item.development && item.development.parent_development) ? item.development.parent_development.commercial_title : '' }}</span>
        <v-icon v-if="item.development && item.development.parent_development" dark x-small
                class="ml-1 mr-1">fas fa-angle-double-right
        </v-icon>

        <span>{{ item.development ? item.development.commercial_title : '' }}</span>
        <v-icon v-if="item.development" dark x-small class="ml-1 mr-1">fas fa-angle-double-right
        </v-icon>

        <span>{{ item.title }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
            v-if="$store.state.auth.user.type !== 2 && $store.state.auth.user.type !== 3 && $store.state.auth.user.type !== 5"
            dark
            text
            @click="$emit('editProjectFD', item)"
        >
          Edit
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-tabs class="custom-scroll" v-model="activeTabDetail" background-color="#002366" left dark grow>
      <v-tabs-slider></v-tabs-slider>
      <v-tab>Details</v-tab>
      <v-tab>Description</v-tab>
      <v-tab>Location</v-tab>
      <v-tab>Social Media Links</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Bank Details</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">SEO</v-tab>
      <v-tab>Media</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Typical Floor Plans</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Internal Layouts</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">External Layouts</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Project Details MP</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Project Details PM</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Payment Plans</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Project Price And Comparison (Transacted)</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Project Price And Comparison (Advertised)</v-tab>
      <v-tab v-if="$store.state.auth.user.type === 1">Summary</v-tab>
    </v-tabs>
    <v-tabs-items touchless v-model="activeTabDetail">
      <v-tab-item>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="3">
              <h6>Title:</h6>
              <p class="hidden-sm-and-down">{{ item.title }}</p>
              <p class="hidden-md-and-up">
                <span>{{ item.country ? item.country.title : '' }}</span>
                <v-icon v-if="item.country" x-small class="ml-1 mr-1">fas fa-angle-double-right</v-icon>

                <span>{{ item.city ? item.city.title : '' }}</span>
                <v-icon v-if="item.city" x-small class="ml-1 mr-1">fas fa-angle-double-right</v-icon>

                <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development.parent_development) ? item.development.parent_development.parent_development.parent_development.parent_development.parent_development.commercial_title : '' }}</span>
                <v-icon
                    v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development.parent_development"
                    x-small class="ml-1 mr-1">fas fa-angle-double-right
                </v-icon>

                <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development) ? item.development.parent_development.parent_development.parent_development.parent_development.commercial_title : '' }}</span>
                <v-icon
                    v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development.parent_development"
                    x-small class="ml-1 mr-1">fas fa-angle-double-right
                </v-icon>

                <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development) ? item.development.parent_development.parent_development.parent_development.commercial_title : '' }}</span>
                <v-icon
                    v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development && item.development.parent_development.parent_development.parent_development"
                    x-small class="ml-1 mr-1">fas fa-angle-double-right
                </v-icon>

                <span>{{ (item.development && item.development.parent_development && item.development.parent_development.parent_development) ? item.development.parent_development.parent_development.commercial_title : '' }}</span>
                <v-icon
                    v-if="item.development && item.development.parent_development && item.development.parent_development.parent_development"
                    x-small class="ml-1 mr-1">fas fa-angle-double-right
                </v-icon>

                <span>{{ (item.development && item.development.parent_development) ? item.development.parent_development.commercial_title : '' }}</span>
                <v-icon v-if="item.development && item.development.parent_development" x-small
                        class="ml-1 mr-1">fas fa-angle-double-right
                </v-icon>

                <span>{{ item.development ? item.development.commercial_title : '' }}</span>
                <v-icon v-if="item.development" x-small class="ml-1 mr-1">fas fa-angle-double-right
                </v-icon>

                <span>{{ item.title }}</span>
              </p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Type:</h6>
              <p>{{ item.project_type ? item.project_type.title : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Project Number:</h6>
              <p>{{ item.project_no ? item.project_no : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Completion Status:</h6>
              <p>{{ item.completion_status ? item.completion_status.title : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Life Cycle:</h6>
              <p>{{ item.life_cycle ? item.life_cycle.title : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Master Development:</h6>
              <p>{{ item.development ? item.development.commercial_title : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Developer:</h6>
              <p>{{ item.developer ? item.developer.full_name : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Plot Number:</h6>
              <p>{{ item.plot_no ? item.plot_no : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Project Configuration:</h6>
              <p>{{ item.configuration ? item.configuration : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Number Of Units:</h6>
              <p>{{ item.no_of_units ? item.no_of_units : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Number Of Sold Units:</h6>
              <p>{{ item.no_of_sold_units ? item.no_of_sold_units : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Number Of Remaining Units:</h6>
              <p>{{ item.no_of_remaining_units ? item.no_of_remaining_units : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Number Of Floor:</h6>
              <p>{{ item.no_of_floor ? item.no_of_floor : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Plot Area:</h6>
              <p>{{ item.plot_area ? item.plot_area + ' (' + item.plot_area_unit + ')' : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Built Up Area:</h6>
              <p>{{ item.built_up_area ? item.built_up_area + ' (' + item.built_up_area_unit + ')' : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Status Percentage:</h6>
              <p>{{ item.status_percentage ? item.status_percentage : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Launch Date:</h6>
              <p>{{ item.launch_date ? formatMomentDate(item.launch_date) : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Registration Date:</h6>
              <p>{{ item.registration_date ? formatMomentDate(item.registration_date) : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Construction Started Date:</h6>
              <p>{{ item.construction_started_date ? formatMomentDate(item.construction_started_date) : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Anticipated Completion Date:</h6>
              <p>{{ item.anticipated_completion_date ? formatMomentDate(item.anticipated_completion_date) : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Handover Date:</h6>
              <p>{{ item.handover_date ? formatMomentDate(item.handover_date) : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Main Contractors:</h6>
              <p>{{ item.main_contractor_titles ? item.main_contractor_titles : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Sub Contractors:</h6>
              <p>{{ item.sub_contractor_titles ? item.sub_contractor_titles : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Architects:</h6>
              <p>{{ item.architect_titles ? item.architect_titles : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Cost Consultants:</h6>
              <p>{{ item.cost_consultant_titles ? item.cost_consultant_titles : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Piling Contractors:</h6>
              <p>{{ item.piling_contractor_titles ? item.piling_contractor_titles : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>MEP Contractors:</h6>
              <p>{{ item.mep_contractor_titles ? item.mep_contractor_titles : '-' }}</p>
            </v-col>
            <v-col cols="12" sm="3">
              <h6>Project Managers
                :</h6>
              <p>{{ item.project_manager_titles ? item.project_manager_titles : '-' }}</p>
            </v-col>
            <v-col cols="12">
              <h6>Special Classifications:</h6>
              <p>{{ item.special_classification_titles ? item.special_classification_titles : '-' }}</p>
            </v-col>
            <v-col cols="12">
              <h6>Amenities:</h6>
              <p>{{ item.amenity_titles ? item.amenity_titles : '-' }}</p>
            </v-col>
            <v-col cols="12">
              <h6>Road Locations:</h6>
              <p>{{ item.road_location_titles ? item.road_location_titles : '-' }}</p>
            </v-col>
            <v-col cols="12">
              <h6>Views:</h6>
              <p>{{ item.view_titles ? item.view_titles : '-' }}</p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <p v-html="item.description ? sanitizeRichHtml(item.description) : '-'"></p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <h6>Location:</h6>
                <p>{{ item.location ? item.location : '-' }}</p>
              </v-col>
              <v-col cols="12" sm="4">
                <h6>Latitude:</h6>
                <p>{{ item.latitude ? item.latitude : '-' }}</p>
              </v-col>
              <v-col cols="12" sm="4">
                <h6>Longitude:</h6>
                <p>{{ item.longitude ? item.longitude : '-' }}</p>
              </v-col>
            </v-row>
<!--            <v-row>-->
<!--              <v-col cols="12" sm="12">-->
<!--                <gmap-map-->
<!--                    :zoom="20"-->
<!--                    :center="center"-->
<!--                    style="width:100%;  height: 400px;"-->
<!--                    :clickable="true"-->
<!--                >-->
<!--                  <gmap-marker-->
<!--                      :key="index"-->
<!--                      v-for="(m, index) in locationMarkers"-->
<!--                      :position="m.position"-->
<!--                  ></gmap-marker>-->
<!--                </gmap-map>-->
<!--              </v-col>-->
<!--            </v-row>-->
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <v-row v-if="item.hasOwnProperty('youtube_videos_links') && item.youtube_videos_links.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Youtube Videos:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.youtube_videos_links" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="item.hasOwnProperty('youtube_playlist_links') && item.youtube_playlist_links.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Youtube Playlist:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.youtube_playlist_links" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="item.hasOwnProperty('virtual_tour_links') && item.virtual_tour_links.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Virtual Tour:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.virtual_tour_links" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="item.hasOwnProperty('website_urls') && item.website_urls.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Website URLS:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.website_urls" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="item.hasOwnProperty('instagram_urls') && item.instagram_urls.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Instagram URLS:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.instagram_urls" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="item.hasOwnProperty('facebook_urls') && item.facebook_urls.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Facebook URLS:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.facebook_urls" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="item.hasOwnProperty('twitter_urls') && item.twitter_urls.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Twitter URLS:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.twitter_urls" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row v-if="item.hasOwnProperty('linkedin_urls') && item.linkedin_urls.length > 0">
              <v-col cols="12" class="pb-0">
                <h6>Linkedin URLS:</h6>
              </v-col>
              <v-col cols="12" sm="3" v-for="(link, index) in item.linkedin_urls" :key="index">
                <v-card class="mb-1">
                  <v-card-text>
                    <p class="mb-1">{{ link.title }}</p>
                    <a target="_blank"
                       :href="link.url">{{ link.url }}</a>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <v-card flat
                v-if="item.hasOwnProperty('project_bank_details') && item.project_bank_details.length > 0"
        >
          <v-card-text v-for="(link, index) in item.project_bank_details" :key="index">
            <v-row>
              <v-col cols="12" sm="3">
                <h6>Bank Name:</h6>
                <p>{{ link.name }}</p>
              </v-col>
              <v-col cols="12" sm="3">
                <h6>Branch Name:</h6>
                <p>{{ link.branch_name }}</p>
              </v-col>
              <v-col cols="12" sm="3">
                <h6>Branch Code:</h6>
                <p>{{ link.branch_code }}</p>
              </v-col>
              <v-col cols="12" sm="3">
                <h6>Swift Code:</h6>
                <p>{{ link.swift_code }}</p>
              </v-col>
              <v-col cols="12" sm="3">
                <h6>Address:</h6>
                <p>{{ link.location }}</p>
              </v-col>
              <v-col cols="12" sm="3">
                <h6>Account Number:</h6>
                <p>{{ link.account_no }}</p>
              </v-col>
              <v-col cols="12" sm="3">
                <h6>IBAN Number:</h6>
                <p>{{ link.iban_no }}</p>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <h6>Meta Title:</h6>
                <p>{{ item.meta_title ? item.meta_title : '-' }}</p>
              </v-col>
              <v-col cols="12">
                <h6>Meta Keywords:</h6>
                <p>{{ item.meta_keywords ? item.meta_keywords : '-' }}</p>
              </v-col>
              <v-col cols="12">
                <h6>Focus Keywords:</h6>
                <p>{{ item.focus_keywords ? item.meta_keywords : '-' }}</p>
              </v-col>
              <v-col cols="12">
                <h6>Meta Description:</h6>
                <p v-html="item.meta_description ? sanitizeRichHtml(item.meta_description) : '-'"></p>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-tabs
            v-model="activeTabDetailInner"
            background-color="primary" left dark>
          <v-tab>Master Plan</v-tab>
          <v-tab>Gallery</v-tab>
          <v-tab>Brochure</v-tab>
          <v-tab v-if="$store.state.auth.user.type === 1">Documents</v-tab>

          <v-tab-item>
            <v-carousel
                height="auto"
                :continuous="false" :cycle="false" hide-delimiters
                v-if="item.hasOwnProperty('master_plan_files') && item.master_plan_files.length > 0">
              <v-carousel-item
                  v-for="(item,i) in item.master_plan_files"
                  :key="i"
              >
                <v-img
                    contain max-height="500"
                    v-if="checkFileExtension(item.extension)"
                    :src="item.file_public_url"
                ></v-img>

                <v-card height="100vh"
                        v-else>
                  <iframe
                      onload="this.style.height = this.contentWindow.document.body.scrollHeight + 'px'"
                      style='height: 100%; width: 100%;' frameborder="0" scrolling="no"
                      :src='item.file_public_url' allowfullscreen></iframe>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </v-tab-item>
          <v-tab-item>
            <Gallery v-if="item.hasOwnProperty('gallery_files') && item.gallery_files.length > 0" :items="item.gallery_files"/>
          </v-tab-item>
          <v-tab-item>
            <v-carousel
                height="auto"
                :continuous="false" :cycle="false" hide-delimiters
                v-if="item.hasOwnProperty('brochure_files') && item.brochure_files.length > 0">
              <v-carousel-item
                  v-for="(item,i) in item.brochure_files"
                  :key="i"
              >
                <v-img
                    contain max-height="500"
                    v-if="checkFileExtension(item.extension)"
                    :src="item.file_public_url"
                ></v-img>

                <v-card height="100vh" v-else>
                  <iframe
                      onload="this.style.height = this.contentWindow.document.body.scrollHeight + 'px'"
                      style="height: 100%; width: 100%;" frameborder="0" scrolling="no"
                      :src='item.file_public_url' allowfullscreen></iframe>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </v-tab-item>
          <v-tab-item v-if="$store.state.auth.user.type === 1">
            <v-carousel
                height="auto"
                :continuous="false" :cycle="false" hide-delimiters
                v-if="item.hasOwnProperty('document_files') && item.document_files.length > 0">
              <v-carousel-item
                  v-for="(item,i) in item.document_files"
                  :key="i"
              >
                <v-img
                    contain max-height="500"
                    v-if="checkFileExtension(item.extension)"
                    :src="item.file_public_url"
                ></v-img>

                <v-card height="100vh" v-else>
                  <iframe
                      onload="this.style.height = this.contentWindow.document.body.scrollHeight + 'px'"
                      style='height: 100%; width: 100%;' frameborder="0" scrolling="no"
                      :src='item.file_public_url' allowfullscreen></iframe>
                </v-card>
              </v-carousel-item>
            </v-carousel>
          </v-tab-item>
        </v-tabs>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <ProjectTypicalFloorPlans
            :moduleTitle="item.title + '\'s Typical Floor Plans'"
            :project="item"
        ></ProjectTypicalFloorPlans>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <ProjectInternalLayouts
            :moduleTitle="item.title + '\'s Internal Layouts'"
            :project="item"
        ></ProjectInternalLayouts>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <ProjectExternalLayouts
            :moduleTitle="item.title + '\'s External Layouts'"
            :project="item"
        ></ProjectExternalLayouts>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <Listings
            modType="project"
            :project="item"
        ></Listings>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <ProjectUnitDetailsPm
            :project="item"
        ></ProjectUnitDetailsPm>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <ProjectPaymentPlans
            :moduleTitle="item.title + '\'s Payment Plans'"
            :project="item"
        ></ProjectPaymentPlans>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <v-tabs v-model="activeTabSecond" background-color="primary" centered dark>
          <v-tab>Sale</v-tab>
          <v-tab>Rent</v-tab>
        </v-tabs>
        <v-tabs-items touchless v-model="activeTabSecond">
          <v-tab-item>
            <ProjectFullTransactions :project="item" purpose="1"/>
          </v-tab-item>
          <v-tab-item>
            <ProjectFullTransactions :project="item" purpose="2"/>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <v-col cols="12">
          <ProjectFullAds :project="item"/>
        </v-col>
      </v-tab-item>
      <v-tab-item v-if="$store.state.auth.user.type === 1">
        <ProjectSummary
            :project="item"
        ></ProjectSummary>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import Listings from "@/view/pages/realstate/listings/Listings";
import ProjectUnitDetailsPm from "@/view/pages/realstate/projects/inc/ProjectUnitDetailsPm";
import ProjectTypicalFloorPlans from "@/view/pages/realstate/projects/inc/ProjectTypicalFloorPlans";
import ProjectInternalLayouts from "@/view/pages/realstate/projects/inc/ProjectInternalLayouts";
import ProjectExternalLayouts from "@/view/pages/realstate/projects/inc/ProjectExternalLayouts";
import ProjectPaymentPlans from "@/view/pages/realstate/projects/inc/ProjectPaymentPlans";
import ProjectFullTransactions from "@/view/pages/realstate/projects/inc/ProjectFullTransactions";
import ProjectSummary from "@/view/pages/realstate/projects/inc/ProjectSummary";
import Gallery from "@/view/pages/realstate/media/Gallery";
import ProjectFullAds from "@/view/pages/realstate/projects/inc/ProjectFullAds";

export default {
  name: 'project-details',
  components: {
    ProjectFullAds,
    Gallery,
    ProjectSummary,
    ProjectFullTransactions,
    Listings,
    ProjectUnitDetailsPm,
    ProjectTypicalFloorPlans,
    ProjectPaymentPlans,
    ProjectInternalLayouts,
    ProjectExternalLayouts
  },
  props: ['item'],
  data() {
    return {
      center: {},
      locationMarkers: [],
    }
  },
  watch: {
    item() {
      this.activeTabDetail = 0
      this.activeTabDetailInner = 0
      this.item.latitude = this.item.latitude ? parseFloat(this.item.latitude) : 0;
      this.item.longitude = this.item.longitude ? parseFloat(this.item.longitude) : 0;
      const marker = {
        lat: this.item.latitude ? parseFloat(this.item.latitude) : 0,
        lng: this.item.longitude ? parseFloat(this.item.longitude) : 0
      };
      this.locationMarkers.push({position: marker});
      this.center = marker;
    }
  },
  mounted() {
    this.item.latitude = this.item.latitude ? parseFloat(this.item.latitude) : 0;
    this.item.longitude = this.item.longitude ? parseFloat(this.item.longitude) : 0;
    const marker = {
      lat: this.item.latitude ? parseFloat(this.item.latitude) : 0,
      lng: this.item.longitude ? parseFloat(this.item.longitude) : 0
    };
    this.locationMarkers.push({position: marker});
    this.center = marker;
    if (this.$route.query.hasOwnProperty('t')) {
      this.activeTabDetail = 14
    }
  },
  methods: {},
  computed: {}
};
</script>